var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63174 7.33325L13.2984 11.9999V23.6666H0.465088V7.33325H8.63174ZM7.66459 9.6666H2.79844V21.3333H10.9651V12.9671L7.66459 9.6666ZM12.1317 3.83325L16.7984 8.4999V20.1666L14.4651 20.1665V9.4671L11.1646 6.1666L3.96509 6.16655V3.83325H12.1317ZM15.6317 0.333252L20.2984 4.9999V16.6666L17.9651 16.6665V5.9671L14.6646 2.6666L7.46509 2.66655V0.333252H15.6317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDoc);
export default __webpack_public_path__ + "static/media/multi-doc.e20717834937187d2dfe2540685fa565.svg";
export { ForwardRef as ReactComponent };